import { MsalProvider } from '@azure/msal-react'
import { QueryClientProvider } from '@tanstack/react-query'
import type { IPublicClientApplication } from '@azure/msal-browser'
import type { ReactNode } from 'react'
import { queryClient } from '@/shared/api/queryClient'
import ToastContainer from '@/shared/components/ui/Toast'
import ModalContainer from '@/shared/components/ui/Modal'

interface AppProvidersProps {
  msalInstance: IPublicClientApplication
  children: ReactNode
}

/**
 * Single place where every app-wide context is composed.
 *
 * The imperative `ToastContainer` / `ModalContainer` hosts are mounted here so
 * that `showToast()` / `showModal()` can be called from anywhere without each
 * feature having to render its own portal target.
 */
export default function AppProviders({ msalInstance, children }: AppProvidersProps) {
  return (
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        {children}
        <ToastContainer />
        <ModalContainer />
      </QueryClientProvider>
    </MsalProvider>
  )
}
